import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import { ReactNode } from 'react';

interface MsalProviderWrapperProps {
    msalInstance: PublicClientApplication | null,
    children: ReactNode
}

const MsalProviderWrapper: React.FC<MsalProviderWrapperProps> = ({ msalInstance, children }) => (
    msalInstance
        ? <MsalProvider key={Date.now().toString()} instance={msalInstance}>{children}</MsalProvider>
        : <React.Fragment key={Date.now().toString()}>{children}</React.Fragment>
)

export default MsalProviderWrapper